module.exports = __webpack_public_path__ + "img/20191120162725360截图20191120161601479.b7d25f6f.jpg";